
import { defineComponent, onMounted, reactive } from "vue";
import Order from "@/components/common/Order.vue";
import $API from "@/services";
import { RouterName } from "@/models/common";
import { IPaymentItem } from "@/models/payment";
import router from "@/router";
import _, { orderBy } from "lodash";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "Order List",
  setup() {

    const {t} = useI18n();

    const state = reactive({
      list: [] as Array<IPaymentItem>,
    });

    const orderClick = (item: IPaymentItem) => {
      router.push({
        name: RouterName.ORDER,
        params: { id: item.PaymentKey.valueOf() },
      });
    };

    const groupBy = () => {
      const group = _.mapValues(
        orderBy(
          _.groupBy(
            Object.values(_.orderBy(state.list, "PaidDateTime").reverse()),
            "PaidMonth"
          ),
          "PaidMonth"
        ).reverse()
      );
      return Object.values(group);
    };
    const displayMonth = (m: string) => {
      if (!(m.length === 6)) return;

      return `${m.substring(0, 4)}.${m.substring(4, 2)}`;
    };

    onMounted(async () => {
      try {
        state.list  = await $API.PaymentsService.getMyPaidList();
      } catch(ex) {
        console.warn(ex);
      }
    });

    return { state, orderClick, groupBy, displayMonth, t };
  },
  components: {
    Order,
  },
});
